{
    "header": {},
    "footer": {},
    "page": {
        "select-device": {
            "fluidnc": "Use this option if you want to install, upgrade or configure your Arabesque controller.",
            "continue": "Continue"
        },
        "connection": {
            "title": "Instalator Arabesque Web",
            "description": "To narzędzie ułatwi instalację lub aktualizację Arabesque na Twoim kontrolerze. Podłącz kontroler do komputera i naciśnij Połącz, aby kontynuować.",
            "connect": "Połącz",
            "connecting": "Łączenie...",
            "establishing-connection": "Łączenie z kontrolerem"
        },
        "home": {
            "description": "Jesteś teraz połączony z urządzeniem, wybierz akcję poniżej",
            "error-while-booting": "Wystąpił błąd podczas uruchamiania, prawdopodobnie z powodu nieprawidłowej konfiguracji.",
            "show-details": "Kliknij, aby wyświetlić szczegóły"
        },
        "file-browser": {
            "title": "Przeglądarka plików",
            "loading": "Ładowanie...",
            "downloading": "Pobieranie...",
            "uploading": "Wysyłanie...",
            "config-missing": "The configuration file \"{{configFilename}}\" is missing, do you want to create it?",
            "create-config": "Utwórz konfigurację",
            "create-new-config": "Utwórz nową konfigurację",
            "upload": "Wyślij",
            "active-config": "Aktywna konfiguracja",
            "select-config": "Wybierz konfigurację",
            "select-as-config": "Ustaw jako konfigurację",
            "edit": "Edytuj",
            "delete": "Usuń",
            "download": "Pobierz"
        },
        "terminal": {
            "title": "Terminal",
            "restarting": "Restartowanie kontrolera...",
            "restart": "Restartuj",
            "restart-description": "Wykonaj reset sprzętowy kontrolera ustawiając DTR/RTS",
            "reset": "Resetuj",
            "reset-description": "Resetuje sterownik poleceniem 0x18",
            "unlock": "Odblokuj",
            "unlock-description": "Odblokuj oprogramowanie",
            "status": "Status",
            "status-description": "Wyświetl status kontrolera",
            "startup": "Wiadomości startowe",
            "startup-description": "Wyświetl wiadomości startowe",
            "version": "Wersja",
            "version-description": "Wyświetl wersję oprogramowania"
        },
        "not-found": {
            "title": "Page not found",
            "go-back-home": "Return back home"
        }
    },
    "panel": {
        "navigation": {
            "home": "Strona główna",
            "install": "Zainstaluj",
            "terminal": "Terminal",
            "file-browser": "Przeglądarka plików",
            "wifi": "WiFi",
            "calibrate": "Kalibruj",
            "stacktrace-decoder": "Decode Stack Trace",
            "restart": "Restartuj",
            "disconnect": "Odłącz"
        },
        "firmware": {
            "install": "Zainstaluj",
            "install-description": "Wybierz, które oprogramowanie chcesz zainstalować na kontrolerze",
            "loading": "Ładowanie...",
            "install-custom-image": "Załaduj własny plik oprogramowania...",
            "show-prereleases": "Pokaż wersje deweloperskie",
            "fetching": "Pobieranie"
        },
        "progress": {
            "title": "Ładowanie",
            "downloading": "Pobieranie pakietu...",
            "validating": "Weryfikacja obrazu...",
            "flashing": "Pakiet jest ładowany na urządzenie..."
        },
        "bootloader": {
            "waiting": "Oczekiwanie na wejście kontrolera w tryb bootloadera...",
            "not-active": "Bootloader nie jest aktywny - Proszę uruchomić przycisk bootowania"
        },
        "unsupported": {
            "title": "Twoja przeglądarka nie jest obsługiwana",
            "description": "Twoja obecna przeglądarka nie jest obsługiwana, użyj Chrome, Edge lub Opera."
        }
    },
    "component": {
        "log": {
            "show-details": "Pokaż szczegóły",
            "hide-details": "Ukryj szczegóły"
        }
    },
    "modal": {
        "installer": {
            "error-reconnecting": "Wystąpił błąd podczas ponownego łączenia, zrestartuj kontroler.",
            "uploading": "Ładowanie...",
            "downloading": "Pobieranie...",
            "downloading-description": "Pobieranie pakietu...",
            "restarting": "Restartowanie...",
            "restarting-description": "Oczekiwanie na ponowne uruchomienie kontrolera...",
            "uploading-files": "Wysyłanie plików...",
            "uploading-files-description": "Pliki są wysyłane...",
            "done": "Zakończono",
            "done-description": "Kontroler został pomyślnie zainstalowany i jest gotowy do użycia.",
            "continue": "Kontynuuj",
            "error": "Błąd!",
            "close": "Zamknij",
            "confirm-installation": "Potwierdź instalację",
            "confirm-installation-description": "To spowoduje zainstalowanie firmware'u \"{{release}}\" do sterownika. {{not}} Spowoduje wymazanie sterownika.",
            "not": "Wyklucz",
            "installation-speed": "Prędkość instalacji",
            "installation-speed-help": "Niektóre kontrolery wymagają niższej prędkości instalacji. Jeśli masz problemy, spróbuj ją zmniejszyć.",
            "install": "Zainstaluj",
            "cancel": "Anuluj",
            "select-image": "Wybierz obraz",
            "select-image-description1": "Jeśli pobrałeś pakiet ręcznie, możesz załadować obraz tutaj.",
            "select-image-description2": "Wybierz plik firmware.bin do załadowania na kontroler.",
            "select-image-button": "Wybierz plik oprogramowania"
        },
        "lost-connection": {
            "description": "Połączenie z kontrolerem zostało utracone.",
            "close": "Zamknij"
        }
    },
    "card": {
        "install": {
            "upgrade-description": "Upgrade Arabesque from",
            "install-description": "Wygląda na to, że Arabesque nie jest zainstalowany na kontrolerze. Czy chcesz zainstalować?",
            "upgrade-button": "Aktualizuj Arabesque",
            "install-button": "Zainstaluj Arabesque"
        },
        "terminal": {
            "open-terminal": "Pokaż terminal",
            "open-terminal-description": "Otwórz terminal szeregowy na kontrolerze."
        },
        "file-browser": {
            "open-browser": "Przeglądarka plików",
            "open-browser-description": "Zarządzaj plikami kontrolera."
        },
        "calibrate": {
            "calibrate": "Kalibruj",
            "calibrate-description": "Skalibruj ustawienia kontrolera."
        },
        "wifi": {
            "configure": "Konfiguracja WiFi",
            "configure-description": "Zarządzaj ustawieniami WiFi kontrolera.",
            "connected-to": "Połączono z",
            "access-point": "Punkt dostępowy (Access Point)"
        },
        "stacktrace": {
            "open": "Decode Stack Trace",
            "description": "Decode ESP32 stack traces using .addrinfo files"
        }
    }
}
